import React from 'react';

const AssuranceEmprunteurPage = () => {
    return (
        <div>
            Assurance Emprunteur
        </div>
    );
};

export default AssuranceEmprunteurPage;